import { StyledToggle } from "@/mds/components/forms/toggle/toggle.style";
import { InputHTMLAttributes } from "react";

export const MDSToggle = (props: Omit<InputHTMLAttributes<HTMLInputElement>, "type">) => {
  const { ...rest } = props;
  return (
    <StyledToggle
      type="checkbox"
      // thesse handlers on the mouse-down and on-click fix a rare issue where the onChange is not called
      onMouseDown={e => {
        e.preventDefault();
      }}
      onClick={e => e.stopPropagation()}
      {...rest}
    />
  );
};
